module.exports = __webpack_public_path__ + "static/media/more-services.846d5c80.svg";